import React from 'react';
import { Row, Col, CheckboxControl } from '@si-armes/dsfr-react';
import { useFormContext } from 'react-hook-form';
import InputFiles from 'components/Commun/Form/InputFiles';
import QuestionsPsychiatriques from './QuestionsPsychiatriques';

const InformationsGeneralesObligatoires = () => {
    const { register, formState, watch } = useFormContext();

    // SIAR-6341 (RG4) : personnalisation du texte de la déclaration sur l'honneur
    // pour les demandes Catégorie C.
    const isCategorieC = watch('isCategorieC') === true;
    const declarationStockageLabel = isCategorieC
        ? "Je déclare sur l'honneur disposer des installations nécessaires à la conservation sécurisée des armes, éléments d'armes et munitions de catégorie C conformément à la réglementation en vigueur."
        : "Je déclare sur l'honneur disposer des installations nécessaires à la conservation sécurisée des armes et matériels conformément à la réglementation en vigueur.";

    return (
        <>
            {/* Déclaration des caractéristiques des armes */}
            <Row gutters>
                <Col lg={12}>
                    <div className="margin-bottom-md">
                        <InputFiles
                            label="Déclaration des caractéristiques des armes et matériels de guerre"
                            {...register('pieceJointes.declarationCaracteristiquesArmes.fichiers', {
                                required: 'Ce champ est obligatoire',
                            })}
                            error={formState.errors?.pieceJointes?.declarationCaracteristiquesArmes}
                            required
                        />
                        <span className="fr-hint-text">
                            Veuillez importer la déclaration lisible et signée précisant les
                            caractéristiques des armes et matériels de guerre détenus
                        </span>
                    </div>
                </Col>
            </Row>

            {/* Questions sur les antécédents psychiatriques */}
            <QuestionsPsychiatriques />

            {/* Déclaration sur l'honneur des conditions de stockage */}
            <Row gutters>
                <Col lg={12}>
                    <div className="margin-top-md">
                        <CheckboxControl
                            id="declarationStockage"
                            label={declarationStockageLabel}
                            name="declarationStockage"
                            {...register('declarationStockage', {
                                required: 'Vous devez accepter cette déclaration pour continuer',
                            })}
                            state={formState.errors?.declarationStockage ? 'error' : null}
                            message={formState.errors?.declarationStockage?.message}
                            required
                        />
                        {!isCategorieC && (
                            <span className="fr-hint-text">
                                Les armes à feu, leurs éléments et leurs munitions de catégorie A et
                                B doivent être conservés dans des coffres-forts ou des armoires
                                fortes adaptés au type et au nombre de matériels détenus ; soit à
                                l’intérieur de pièces fortes comportant une porte blindée et dont
                                les ouvrants sont protégés par des barreaux.
                            </span>
                        )}
                    </div>
                </Col>
            </Row>
        </>
    );
};

export default InformationsGeneralesObligatoires;
